var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c('AppHeader',{attrs:{"default-index":5}})],1),_c('Banner',{attrs:{"list":_vm.bannerList}}),_c('Block',{attrs:{"title":"志愿者招募"}}),_c('VolunteerItem',{attrs:{"extensionData":_vm.extensionObject,"tutorData":_vm.tutorObject}}),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }